import React from 'react';
import { TFunction } from 'i18next';
import { Flex } from '@mss/mss-component-library';
import Switch from 'formik-antd/lib/switch';

const ToggleEnabled = ({
  t,
  checked,
  onSubmit,
  setFieldValue,
  disabled,
}: {
  t: TFunction;
  checked: boolean;
  onSubmit: any;
  setFieldValue: Function;
  disabled?: boolean;
}) => (
  <Flex
    h="center"
    v="center"
    onClick={e => {
      e.stopPropagation();
      if (onSubmit && !disabled) onSubmit();
      setFieldValue('enabled', !checked);
    }}
  >
    <Switch size="small" className="mr-1" name="enabled" disabled={disabled} />
    {t('Enabled')}
  </Flex>
);

export default ToggleEnabled;
